import { isEqual, isEmpty, isObject, last, first } from 'underscore';
import Log from 'forms-utils-lib/logger/Logger';
import I18n from 'I18n';
import { DISABLE_COOKIE_SUBMISSION, CSS, NOTIFY_HUBSPOT_OWNER, LANG
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'Form... Remove this comment to see the full error message
} from 'FormsCommonComponents/form-definition/constants/MetaDataKeys';
import { EXTERNAL_EDITORS } from 'FormsUI/constants/ExternalEditors';
import PublishButtonTypes from 'FormsUI/constants/PublishButtonTypes';
import PostSubmissionOptions from 'forms-utils-lib/constants/formDefinition/PostSubmissionOptions';
import FormKeys from 'forms-utils-lib/constants/formDefinition/FormKeys';
import isContactEmailField from 'forms-utils-lib/formField/utils/isContactEmailField';
import isLegalConsent from 'forms-utils-lib/legalConsent/utils/isLegalConsent';
export const DEFAULT_STYLE = {
  fontFamily: 'arial, helvetica, sans-serif',
  backgroundWidth: '100%',
  backgroundColor: 'transparent',
  borderRadius: '0px',
  padding: '0px',
  labelTextColor: '#212D3A',
  linkColor: '#0000EE',
  clickedLinkColor: '#551A8B',
  labelTextSize: '13px',
  helpTextColor: '#516383DE',
  helpTextSize: '11px',
  legalConsentTextColor: '#33475B',
  legalConsentTextSize: '14px',
  thankYouTextColor: '#33475B',
  thankYouTextSize: '16px',
  submitColor: '#FF7A59',
  submitAlignment: 'left',
  submitFontColor: '#FFFFFF',
  submitSize: '12px',
  paginationProgressColor: '#598AFF',
  paginationProgressTextColor: '#33475B',
  paginationProgressShow: true,
  paginationProgressTransition: 'fade',
  paginationProgressTheme: 'default',
  paginationContentUseScroll: false,
  paginationContentScrollHeight: '100%'
};
const LEGAL_CONSENT = 'legalConsentOptions';
export const isCOSOrTicket = editor => [EXTERNAL_EDITORS.COS, EXTERNAL_EDITORS.TICKET].indexOf(editor) > -1;

// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'Form... Remove this comment to see the full error message
import { FormErrors } from 'FormsUI/api/Forms';
import parseJSON from 'FormsUI/utils/json/parseJSON';
const hasChangedDefaultStyle = styles => Object.keys(styles).some(key => {
  const defaultValue = DEFAULT_STYLE[key];
  const value = styles[key];
  return value !== defaultValue;
});
export const getPublishType = ({
  isPublished,
  externalEditor
}) => {
  if (isCOSOrTicket(externalEditor)) {
    return PublishButtonTypes.COS_UPDATE;
  } else if (isPublished) {
    return PublishButtonTypes.UPDATE;
  } else {
    return PublishButtonTypes.PUBLISH;
  }
};
export const getPublishExtraJson = (formDefinition, postSubmissionOptionType) => {
  const {
    captchaEnabled,
    ignoreCurrentValues,
    formFieldGroups,
    notifyRecipients,
    metaData,
    redirect
  } = formDefinition;
  let hasSmartFields = false;
  let hasQueuedFields = false;
  let hasRichText = false;
  let hasDependentFields = false;
  let hasSplitRows = false;
  let hasFreeMailBlocked = false;
  let hasNotifyHubSpotOwner = false;
  let hasCookieTracking = true;
  let hasDefaultStyling = true;
  let numberFormFields = 0;
  let hasConsent = false;
  let hasTranslation = false;
  const hasSimpleRedirects = !isEmpty(redirect) && postSubmissionOptionType === PostSubmissionOptions.REDIRECT_PAGE;
  const hasNotifyEmailAddresses = notifyRecipients ? notifyRecipients.split(',').length > 0 && !isEmpty(notifyRecipients.split(',')[0]) : false;
  if (Array.isArray(formFieldGroups)) {
    formFieldGroups.forEach(formFieldGroup => {
      hasSmartFields = hasSmartFields || formFieldGroup.isSmartGroup;
      hasQueuedFields = hasQueuedFields || !formFieldGroup.default;
      hasRichText = hasRichText || formFieldGroup.richText && !isEmpty(formFieldGroup.richText.content);
      hasSplitRows = hasSplitRows || formFieldGroup.fields.length > 1;
      formFieldGroup.fields.forEach(formField => {
        numberFormFields += 1;
        hasDependentFields = hasDependentFields || formField.dependentFieldFilters && formField.dependentFieldFilters.length > 0;
        if (isContactEmailField(formField)) {
          hasFreeMailBlocked = formField.validation && formField.validation.useDefaultBlockList;
        }
      });
    });
  }
  if (Array.isArray(metaData)) {
    metaData.forEach(data => {
      if (data.name === NOTIFY_HUBSPOT_OWNER) {
        hasNotifyHubSpotOwner = data.value === 'true';
      }
      if (data.name === DISABLE_COOKIE_SUBMISSION) {
        hasCookieTracking = data.value !== 'true';
      }
      if (data.name === CSS) {
        hasDefaultStyling = data.value !== '';
      }
      if (data.name === LEGAL_CONSENT) {
        hasConsent = true;
      }
      if (data.name === LANG && 'lang' in I18n && 'locale' in I18n) {
        hasTranslation = data.value !== I18n.lang && data.value !== I18n.locale;
      }
    });
  }
  const hasChangedDefaultStyles = hasChangedDefaultStyle(formDefinition.style);
  return {
    publishType: 'update',
    hasCaptcha: captchaEnabled,
    hasPrepopulation: ignoreCurrentValues,
    hasNotifyEmailAddresses,
    postSubmissionOptionType,
    hasSmartFields,
    hasQueuedFields,
    hasRichText,
    hasSplitRows,
    numberFormFields,
    hasDependentFields,
    hasFreeMailBlocked,
    hasNotifyHubSpotOwner,
    hasCookieTracking,
    hasDefaultStyling,
    hasChangedDefaultStyles,
    hasConsent,
    hasSimpleRedirects,
    hasTranslation
  };
};
export const getFormattedDefinition = (postSubmissionOption = '', formDefinition, recipients = []) => {
  const formattedStyle = JSON.stringify(formDefinition.style);

  // Stringify metaData values
  const formattedMetaData = formDefinition[FormKeys.META_DATA].map(({
    name,
    value
  }) => {
    if (isObject(value) || isLegalConsent(value)) {
      return {
        name,
        value: JSON.stringify(value)
      };
    }
    return {
      name,
      value
    };
  });
  let formattedFormDefinition = Object.assign({}, formDefinition, {
    [FormKeys.STYLE]: formattedStyle,
    [FormKeys.META_DATA]: formattedMetaData
  });
  if (isEqual(postSubmissionOption, PostSubmissionOptions.THANK_YOU_MESSAGE)) {
    formattedFormDefinition = Object.assign({}, formattedFormDefinition, {
      redirect: ''
    });
  } else if (isEqual(postSubmissionOption, PostSubmissionOptions.REDIRECT_PAGE)) {
    formattedFormDefinition = Object.assign({}, formattedFormDefinition, {
      inlineMessage: ''
    });
  }
  if (isEmpty(last(recipients))) {
    // Remove empty input from list
    formattedFormDefinition = Object.assign({}, formattedFormDefinition, {
      notifyRecipients: recipients.slice(0, recipients.length - 1).join(',')
    });
  }
  formattedFormDefinition = Object.assign({}, formattedFormDefinition, {
    metaData: formattedMetaData
  });
  return formattedFormDefinition;
};
export const getErrorType = (xhr, fallback) => {
  switch (xhr.status) {
    case 403:
      return FormErrors.NOT_ENOUGH_PRIVILEGES;
    default:
      return fallback;
  }
};
export const parseErrorResponse = (xhr, requestName = 'REQUEST') => {
  const responseText = parseJSON(xhr.responseText, {
    type: null
  }, error => {
    Log.warn(`Could not parse ${requestName} error type from XHR response.`, {
      error,
      xhr,
      responseText: xhr.responseText,
      responseStatus: xhr.status
    });
  });
  const errorType = getErrorType(xhr, responseText.type);
  return {
    errorType,
    responseText
  };
};
const getFieldErrors = formFieldValidationErrors => {
  if (!formFieldValidationErrors) return [];
  const errorsArr = Object.values(formFieldValidationErrors);
  return errorsArr.reduce((errors, error) => [/* eslint-disable-next-line hubspot-dev/no-reduce-accumulator-copy */
  ...errors, ...error.map(({
    formFieldValidationErrorOption
  }) => formFieldValidationErrorOption)], []);
};
export const getDraftErrorOptions = ({
  errorType,
  responseText
}) => {
  const {
    formFieldValidationErrors
  } = responseText;
  const errors = getFieldErrors(formFieldValidationErrors);
  const fieldErrorType = errors.length >= 1 ? first(errors) : errorType;
  const showGenericError = !errors.length;
  const options = {
    notification: true,
    errors: {},
    genericNotification: false
  };
  switch (errorType) {
    case FormErrors.FORM_FIELDS_NOT_VALID:
      options.genericNotification = showGenericError;
      options.errors = {
        fields: responseText.formFieldValidationErrors
      };
      break;
    default:
      break;
  }
  return {
    options,
    fieldErrorType
  };
};
export const getSaveErrorOptions = ({
  errorType,
  responseText
} = {}) => {
  const options = {
    notification: true
  };
  switch (errorType) {
    case FormErrors.FORM_FIELDS_NOT_VALID:
      options.genericNotification = true;
      options.errors = {
        fields: responseText.formFieldValidationErrors
      };
      break;
    default:
      options.errors = {};
      break;
  }
  return options;
};
export const validateFormByPostSubmissionOption = ({
  formDefinition,
  postSubmissionOption
}) => {
  const isThankYouInvalid = isEqual(postSubmissionOption, PostSubmissionOptions.THANK_YOU_MESSAGE) && (isEmpty(formDefinition.inlineMessage) || isEqual(formDefinition.inlineMessage, '<p></p>'));
  const isRedirectPageInvalid = isEqual(postSubmissionOption, PostSubmissionOptions.REDIRECT_PAGE) && isEmpty(formDefinition.redirect);
  if (isThankYouInvalid) {
    return {
      valid: false,
      type: PostSubmissionOptions.THANK_YOU_MESSAGE
    };
  } else if (isRedirectPageInvalid) {
    return {
      valid: false,
      type: PostSubmissionOptions.THANK_YOU_MESSAGE
    };
  } else {
    return {
      valid: true,
      type: null
    };
  }
};